import { render, staticRenderFns } from "./Maatwerkroute.vue?vue&type=template&id=011fce4c&"
import script from "./Maatwerkroute.vue?vue&type=script&lang=js&"
export * from "./Maatwerkroute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports